// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Zai-toast {
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
  width: 432px;
  margin: -22px;
  padding: 20px;
  background-color: #2b2b2b;
  border: 2px solid #d0b2ff;
  border-radius: 16px;
  cursor: pointer;
}
.Zai-toast .Zai-toast-message {
  flex: 1 1;
  min-width: 0;
  text-align: left;
  color: white;
}
.Zai-toast .Zai-toast-title {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
.Zai-toast .Zai-toast-close {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: #d0b2ff;
}

.Zai-toast ~ button {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/modules/zai/zai-background-notification/zai-background-notification.styles.scss"],"names":[],"mappings":"AAKA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AAJF;AAME;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAJJ;AAOE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AALJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AANJ;;AAYA;EACE,aAAA;AATF","sourcesContent":["// The toast package wraps `content` in its own themed card (padding: 20px, border: 2px,\n// border-radius: 16px) whose colors follow the app's current theme. The Figma design wants\n// a fixed dark card regardless of theme, so this overlays the wrapper's box entirely:\n// -22px cancels its 20px padding + 2px border, letting our own background/border/radius\n// repaint the full card on top of it.\n.Zai-toast {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  width: 432px;\n  margin: -22px;\n  padding: 20px;\n  background-color: #2b2b2b;\n  border: 2px solid #d0b2ff;\n  border-radius: 16px;\n  cursor: pointer;\n\n  .Zai-toast-message {\n    flex: 1;\n    min-width: 0;\n    text-align: left;\n    color: white;\n  }\n\n  .Zai-toast-title {\n    display: inline-block;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    vertical-align: bottom;\n  }\n\n  .Zai-toast-close {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 20px;\n    height: 20px;\n    padding: 0;\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #d0b2ff;\n  }\n}\n\n// Hides the toast package's own default close \"×\" button (always rendered as a sibling\n// after `content`), since this toast supplies its own close icon matching the Figma design.\n.Zai-toast ~ button {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
